{
    "NAME": "TelModuleStatusListLanguage",
    "TelModuleStatusList_Title": "Status do módulo telefônico",
    "TelModuleStatusList_Column_TelSys": "Servidor de telefonia",
    "TelModuleStatusList_Column_ClassName": "Nome da turma",
    "TelModuleStatusList_Column_Type": "Tipo",
    "TelModuleStatusList_Column_Version": "Versão",
    "TelModuleStatusList_Column_Status": "Status",
    "TelModuleStatusList_Column_LastError": "Último erro",
    "TelModuleStatusList_Column_LastErrorDateTime": "Data\/hora do último erro",
    "TelModuleStatusList_Empty": "Não há informações disponíveis sobre o status do módulo telefônico."
}